import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';

import { ZoomMtg } from '@zoom/meetingsdk';
import {HttpClient} from '@angular/common/http';
import {DOCUMENT} from '@angular/common';

// ZoomMtg.preLoadWasm();
// ZoomMtg.prepareWebSDK();

@Component({
    selector: 'youtube-page',
    templateUrl: './youtube.page.html',
    styleUrls: ['./youtube.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})

export class YoutubePage implements OnInit {
  ngOnInit() {
  }
}
